import Vue from 'vue';
import Router from 'vue-router';
import MainLayout from '../layouts/MainLayout.vue';
import Login from '../views/Login.vue';
import Dashboard from '../views/Dashboard.vue';
import Agents from '../views/Agents.vue';
import QuickReplies from '../views/QuickReplies.vue';
import Faq from '../views/Faq.vue';
import Widget from '../views/Widget.vue';
import { getToken } from '../utils/auth';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/', redirect: '/dashboard' },
    { path: '/login', component: Login },
    {
      path: '/',
      component: MainLayout,
      children: [
        { path: 'dashboard', component: Dashboard },
        { path: 'agents', component: Agents },
        { path: 'quick-replies', component: QuickReplies },
        { path: 'faq', component: Faq },
        { path: 'widget', component: Widget }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  const token = getToken();
  if (to.path !== '/login' && !token) return next('/login');
  if (to.path === '/login' && token) return next('/dashboard');
  return next();
});

export default router;

